import React from "react";

const Page404 = () => {
  return (
    <div className="nopages">
      <h1>Page404</h1>
      <p>查無此頁面</p>
    </div>
  );
};

export default Page404;
